module.exports = __webpack_public_path__ + "img/gtzy1_zhTc.87651320.png";